<template>
    <div class="modal fade show my-2" aria-labelledby="addNewCardTitle" style="display: block; background: #1c1d1c33">
        <div class="modal-dialog modal-lg modal-dialog-centered" ref="modalRef">
            <div class="modal-content">
                <div class="row">
                    <div class="col-12">
                        <div class="d-flex justify-content-between px-1 my-1 align-item-center">
                          <h1 class="mb-0">{{ title }}</h1>
                            <button
                                @click="onClickClose"
                                type="button"
                                class="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                    </div>
                </div>

                <hr class="mt-0 mb-0">

                <div class="pb-2">
                  <div class="row mx-2">
                    <div class="col-12 col-md-6">
                      <label class="align-middle">Branch</label>
                      <v-select
                          placeholder="Select Branch"
                          v-model="formData.branch_id"
                          :options="branchList"
                          label="name"
                          :reduce="name => name.id"
                      />
                    </div>
                    <div class="col-12 col-md-6">
                      <label class="align-middle">Department</label>
                      <v-select
                          placeholder="Select Department"
                          v-model="formData.department_id"
                          :options="departmentList"
                          label="name"
                          :reduce="name => name.id"
                      />
                    </div>

                    <div class="col-12 col-md-6">
                      <label class="align-middle">Employee</label>
                      <AsyncSelect
                          placeholder="Select Employee"
                          v-model="formData.contact_profile_id"
                          :api-service="fetchContactProfiles"
                          :additional-query="{roles: 'employee', status: 'active'}"
                          label="name"
                          :reduce="name => name.id"
                      />
                    </div>

                    <div class="col-12 col-md-6" v-if="false">
                    <div class="mb-1">
                        <label class="form-label" for="mobileNo">Effective Date </label>
                        <input
                            class="form-control invoice-edit-input date-picker flatpickr-input flatpickr-mobile"
                            tabindex="1"
                            type="date"
                            placeholder=""
                            v-model="formData.effective_date"
                        >
                      </div>
                    </div>

                    <div class="col-12 col-md-6">
                      <div class="mb-1">
                        <label class="form-label" for="mobileNo">Calculation Type </label>
                        <v-select
                            placeholder="Select Calculation Type"
                            v-model="formData.calculation_type"
                            :options="payrollPreferenceCalculationType"
                            :reduce="name => name.value"
                            label="name"
                        />
                      </div>
                    </div>

                    <div class="col-12 col-md-6">
                      <div class="mb-1">
                        <label class="form-label" for="mobileNo">Value </label>
                        <input
                            class="form-control invoice-edit-input"
                            tabindex="1"
                            type="number"
                            step="any"
                            placeholder=""
                            v-model="formData.value"
                        >
                      </div>
                    </div>

                    <div class="col-12 col-md-6">
                      <div class="mb-1">
                        <label class="form-label" for="mobileNo">Rounding Type </label>
                        <v-select
                            placeholder="Select Rounding Type"
                            v-model="formData.rounding_type"
                            :options="payrollPreferenceRoundingType"
                            :reduce="name => name.value"
                            label="name"
                        />
                      </div>
                    </div>

                    <div class="col-12 text-center mb-2 mt-2">
                      <button :disabled="loading" @click="submit" type="button" class="btn btn-primary full-width me-1 waves-effect waves-float waves-light">
                        <div v-if="loading" class="spinner-border spinner-border-sm text-light" role="status">
                          <span class="visually-hidden">Loading...</span>
                        </div>
                        Submit
                      </button>
                    </div>
                    </div>
                 </div>
            </div>
        </div>
        <Loader v-if="loader"/>

    </div>
</template>

<script setup>
import Loader from "@/components/atom/LoaderComponent";
import {inject, onMounted, ref, watch} from "vue";
import { useStore } from "vuex";
import { useRoute } from 'vue-router';
import useDate from '@/services/utils/day'
import handleHrPayroll from "@/services/modules/hrPayroll/hrPayroll";
import handleBranches from "@/services/modules/procurement/organization-settings/branch";
import handleDepartments from "@/services/modules/procurement/organization-settings/department";
import AsyncSelect from "@/components/molecule/input-field/AsyncSelect.vue";
import handleContact from '@/services/modules/contact'

const props = defineProps({
    formData:{
      type:Object,
      default:{}
    },
    title: {
      default: null
    }
});

const emit = defineEmits(['getData', 'close']);
const $store = useStore();
const $route = useRoute();
const modalRef = ref(null);
const loading = ref(false);
const isEdit = ref(false);
const loader = ref(false);
const showError = inject('showError');
const showSuccess = inject('showSuccess');
let branchList = ref([])
let departmentList = ref([])
let payrollPreferenceCalculationType = ref([])
let payrollPreferencePayrollDaysType = ref([])
let payrollPreferenceRoundingType = ref([])

const {
  fetchTypes,
  createPayrollPreference,
  updatePayrollPreference
} = handleHrPayroll()
const { fetchBranchList } = handleBranches()
const { fetchDepartmentList } = handleDepartments()
const { fetchContactProfiles } = handleContact()

const submit = async() => {
    const query = getQuery();
    loading.value = true;
    if (isEdit.value){
      await updateData(query)
      return
    }
    await storeData(query)
}

const storeData = async (query) => {
  let payrollPreferenceData = {};
  payrollPreferenceData.branch_id = props.formData.branch_id;
  payrollPreferenceData.department_id = props.formData.department_id;
  payrollPreferenceData.contact_profile_id = props.formData.contact_profile_id;
  payrollPreferenceData.type = props.formData.type;
  payrollPreferenceData.sub_type = props.formData.sub_type;
  payrollPreferenceData.effective_date = props.formData.effective_date;
  payrollPreferenceData.calculation_type = props.formData.calculation_type;
  payrollPreferenceData.value = props.formData.value;
  payrollPreferenceData.rounding_type = props.formData.rounding_type;
  payrollPreferenceData.status = 'active';

  await createPayrollPreference(payrollPreferenceData, query).then((res) => {
    loading.value = false
    if (!res.status) return showError(res.message)
    emit("getData");
    onClickClose();
    showSuccess(res.message)
  }).catch(err => {
    console.log(err)
  }).finally(() => {
    loading.value = false
  })
}

const updateData = async (query) => {
  let payrollPreferenceData = {};
  payrollPreferenceData.branch_id = props.formData.branch_id;
  payrollPreferenceData.department_id = props.formData.department_id;
  payrollPreferenceData.contact_profile_id = typeof props.formData.contact_profile_id === 'object'
      ? props.formData.contact_profile_id.id
      : props.formData.contact_profile_id;

  payrollPreferenceData.type = props.formData.type;
  payrollPreferenceData.sub_type = props.formData.sub_type;
  payrollPreferenceData.effective_date = props.formData.effective_date;
  payrollPreferenceData.calculation_type = props.formData.calculation_type;
  payrollPreferenceData.value = props.formData.value;
  payrollPreferenceData.rounding_type = props.formData.rounding_type;
  payrollPreferenceData.id = props.formData.id;
  payrollPreferenceData.status = 'active';

  await updatePayrollPreference(payrollPreferenceData, payrollPreferenceData.id, query).then((res) => {
    loading.value = false
    if (!res.status) return showError(res.message)
    emit("getData");
    onClickClose();
    showSuccess(res.message)
  }).catch(err => {
    console.log(err)
  }).finally(() => {
    loading.value = false
  })
}

function getQuery() {
  return `?company_id=${$route.params.companyId}`;
}

const getBranchList = async () => {
  let query = getQuery();
  branchList.value = []

  await fetchBranchList(query).then(res => {
    if (!res.status){
      branchList.value = []
      return
    }
    branchList.value = res.data;
  }).catch(err => {
    console.log(err)
  })
}

const getDepartmentList = async () => {
  let query = getQuery();
  departmentList.value = []

  await fetchDepartmentList(query).then(res => {
    if (!res.status){
      departmentList.value = []
      return
    }
    departmentList.value = res.data;
  }).catch(err => {
    console.log(err)
  })
}

const getTypes = async () => {
  let query = getQuery();
  payrollPreferencePayrollDaysType.value = [];
  payrollPreferenceCalculationType.value = [];
  payrollPreferenceRoundingType.value = [];
  await fetchTypes(query).then(res => {
    if (!res.status){
      return
    }
    let data = res.data;
    const calculationTypeMap = {
      'overtime_policy:rate': ['fixed', 'percentage'],
      'overtime_policy:hour': ['fixed'],
      'attendance_deduction:late_in': ['days'],
      'attendance_deduction:early_exit': ['days'],
    };

    const key = `${props.formData.type}:${props.formData.sub_type}`;

    payrollPreferenceCalculationType.value = calculationTypeMap[key]
        ? data.payrollPreferenceCalculationType.filter(item =>
            calculationTypeMap[key].includes(item.value)
        )
        : data.payrollPreferenceCalculationType;

    payrollPreferencePayrollDaysType.value = data.payrollPreferencePayrollDaysType;
    payrollPreferenceRoundingType.value = data.payrollPreferenceRoundingType;
  }).catch(err => {
    console.log(err)
  })
}

watch(() => props.formData, (newVal) => {
  if (newVal.is_edit){
    isEdit.value = true;
  }
}, { immediate: true, deep: true })

function onPageReload() {
  loader.value=true
  Promise.all([
    getBranchList(),
    getDepartmentList(),
    getTypes(),
  ]).finally(() => {
    loader.value = false
  })

  props.formData.effective_date =  new Date().toISOString().split('T')[0]
}

const onClickClose = () => {
  emit('close');
};

onMounted(() => {
  onPageReload();
})

</script>
